import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Highcharts, { isNumber } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { moneyFormatter } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { getTahun } from '../../utils/Filter';
import { API } from '../../api/api';
import EmptyData from './EmptyData';

HighchartsMore(Highcharts);

const colors = ['#f0a18c', '#f05377', '#b85382', '#564887', '#074c89'];
const grades = ['A', 'B', 'C', 'D', 'E'];

const FindPriceByTime = () => {
  const dispatch = useDispatch();
  const { chart, selected_cari_harga } = useSelector((state) => state.checkPriceReducer);

  const [loggedIn, setLoggedIn] = useState(false);
  const [yearList, setYearList] = useState([{ value: '2004', label: '2004' }]);

  // year options will be between selected start year to end year
  function filterByYear(value) {
    return value.value >= selected_cari_harga.startYear && value.value <= selected_cari_harga.endYear;
  }

  // chart by time only shown if array contains value
  function chartByTimeShown(series) {
    const perYear = series.map((item) => {
      return item.data.some(isNumber);
    });
    return perYear.includes(true);
  }

  useEffect(() => {
    getTahun(
      selected_cari_harga.brand,
      selected_cari_harga.series,
      selected_cari_harga.tipe,
      selected_cari_harga.silinder
    ).then((res) => setYearList(res.filter(filterByYear)));
  }, []);

  useEffect(() => {
    if (localStorage.getItem('id') != null) {
      setLoggedIn(true);
    }
  }, []);

  function onChangeYear(event) {
    axios
      .get(API.service.time, {
        params: {
          ...selected_cari_harga,
          year: event.target.value,
        },
      })
      .then((res) => {
        const data = res.data.data;

        let series4 =
          data.item.length > 0
            ? grades.map((grade, i) => {
              const { price } = data.item.find((e) => e.grade === grade) || {
                price: [].fill(null, 0, 5),
              };
              return {
                name: `Grade ${grade}`,
                data: price.map((p) => (p > 0 ? parseInt(p) : null)),
                color: colors[i],
              };
            })
            : null;

        dispatch({
          type: 'SET_CHART',
          value: {
            ...chart,
            chart4: {
              series: series4,
              title: data.title,
            },
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const options = {
    chart: {
      renderTo: 'chart4',
    },
    title: {
      text: chart.chart4 ? chart.chart4.title : '',
    },
    subtitle: {
      text: 'Grafik Harga Terbentuk Berdasarkan Waktu',
    },
    xAxis: {
      title: 'Waktu',
      tickInterval: 1,
      labels: {
        formatter: function () {
          return this.value + ' Bulan';
        },
      },
    },
    plotOptions: {
      series: { pointStart: 1 },
      yAxis: 1,
    },
    yAxis: {
      min: 0,
      title: 'Harga Kendaraan',
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
    },
    tooltip: {
      shared: false,
      useHTML: true,
      formatter: function () {
        return (
          `<span style="font-size:12px; font-weight: bold">${this.x} Bulan</span><table>` +
          `<tr style="font-size: 14px">
                    <td style="padding:0">Harga</td>
                    <td style="padding:0px 5px;">: ` +
          moneyFormatter(this.y) +
          `</td>
                </tr></table>`
        );
      },
    },
    responsive: [],
    credits: { enabled: false },
    series: loggedIn ? (chart.chart4 ? [...chart.chart4.series] : []) : [],
  };

  return (
    <>
      <div id="chart4" className="col-xl-12">
        {selected_cari_harga.startYear !== selected_cari_harga.endYear && (
          <div className="w-100 d-flex align-items-center justify-content-end p-2">
            <select className="filter-year" onChange={(e) => onChangeYear(e)}>
              {yearList.map((item, index) => {
                return (
                  <option
                    value={item.value}
                    key={index}
                    selected={selected_cari_harga.year === item.value}
                    disabled={item.value === 'label'}
                  >
                    {item.label}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {chartByTimeShown(options.series) ? (
          <HighchartsReact highcharts={Highcharts} options={options} />
        ) : (
          <EmptyData title={options.title.text} subTitle={options.subtitle.text} />
        )}
      </div>
    </>
  );
};

export default FindPriceByTime;
